import React, { useEffect, useState, VFC } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import { useHistory } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { ROLES } from '../auth/enums/roles';
import { useGetMeQuery } from '../auth/api/authApi';
import { ROUTES } from './routes';
import AccessDenied from '../error/AccessDenied';

interface ProtectedRouteProps {
  component: React.ElementType;
  allowedRoles: Array<ROLES>;
  path: string;
}

const isAllowed = (AOne: any[], ATwo: any[]) => {
  for (const EOne of AOne) {
    if (ATwo.includes(EOne)) return true;
  }
  return false;
};

const ProtectedRoute: VFC<ProtectedRouteProps> = ({ component: Component, allowedRoles, ...rest }) => {
  const history = useHistory();
  const { data: me, isSuccess } = useGetMeQuery();
  const [redirect, setRedirect] = useState<boolean>();
  useEffect(() => {
    if (isSuccess) {
      if (!isAllowed(allowedRoles, me.roles)) {
        history.push(ROUTES.ERROR_403);
        setRedirect(true);
      } else {
        TagManager.dataLayer({
          dataLayer: {
            username: me.username,
          },
        });
      }
    }
  }, [isSuccess, me]);

  if (redirect) {
    return <Route {...rest} render={() => <Route component={AccessDenied} />} />;
  }
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  allowedRoles: PropTypes.array.isRequired,
};

export default ProtectedRoute;
